export class Numerator {
  constructor(startFrom = 1) {
    this.startFrom = startFrom;
    this.counter = 0;
    this.reset();
  }

  inc() {
    return this.counter++;
  }

  reset() {
    if (this.counter !== this.startFrom) {
      this.counter = this.startFrom;
    }
  }

  formatInc(str) {
    return str.replaceAll('#NUMBER#', this.inc());
  }
}
